import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import {
  Box,
  CenterSpinner,
  EvrCode,
  EvrCompare,
  EvrCube,
  EvrFileEmpty,
  EvrFingerTap,
  EvrLifeBuoy,
  Flex,
  Link
} from '../../primitives'
import { EvrColorSampler } from '../../primitives/Icons/EvrColorSampler'
import { EvrUserPlus } from '../../primitives/Icons/EvrUserPlus'

export const UpgradeSubscriptionModal = ({ isOpen, onClose, allowAddingTeamMembers, isLoading }) => {

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'md'} data-testid="upgrade-subscription-modal">
      <ModalOverlay />
      <ModalContent>
        {isLoading ? (
          <CenterSpinner />
        ) : (
          <>
            <ModalHeader color="navy.100" fontSize={'md'}>
              Upgrade Now
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
              color="navy.100"
              borderTop="1px solid"
              borderColor={'gray.50'}
              display={'flex'}
              flexDir={'column'}
              gap={8}
            >
              <Text>
                You have reached the maximum amount of team members allowed on your subscription
                plan.
              </Text>

              <Text>Please upgrade your plan to create additional team members.</Text>
              <Box gap={2} display={'flex'} flexDir={'column'}>
                <Flex gap={3}>
                  <EvrFileEmpty w="20px" h="20px" />
                  <Text fontSize={'sm'}>Unlimited Documents </Text>
                </Flex>
                <Flex gap={3}>
                  <EvrCompare w="20px" h="20px" />
                  <Text fontSize={'sm'}>Volume or Unlimited Templates</Text>
                </Flex>
                <Flex gap={3}>
                  <EvrCode w="20px" h="20px" />
                  <Text fontSize={'sm'}>Volume API Documents</Text>
                </Flex>
                <Flex gap={3}>
                  <EvrUserPlus w="20px" h="20px" />
                  <Text fontSize={'sm'}>Volume Team Member Seats</Text>
                </Flex>
                <Flex gap={3}>
                  <EvrCube w="20px" h="20px" />
                  <Text fontSize={'sm'}>Advanced Integrations </Text>
                </Flex>
                <Flex gap={3}>
                  <EvrLifeBuoy w="20px" h="20px" />
                  <Text fontSize={'sm'}>Dedicated Support </Text>
                </Flex>
                <Flex gap={3}>
                  <EvrFingerTap w="20px" h="20px" />
                  <Text fontSize={'sm'}>In-Person Signing</Text>
                </Flex>
                <Flex gap={3}>
                  <EvrColorSampler w="20px" h="20px" />
                  <Text fontSize={'sm'}>Custom Branding</Text>
                </Flex>
              </Box>
              <Box borderTop="1px solid" borderColor={'gray.50'} mx="-6" gap={3}>
                <ModalFooter display={'flex'} justifyContent={'flex-start'}>
                  {allowAddingTeamMembers ? (
                    <>
                      <Link
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        fontSize={'14px'}
                        href={'/subscription'}
                        testId="new-team-member-link"
                        bg={'var(--chakra-colors-indigo-100) !important'}
                        textColor={'#fff !important'}
                        variant="primary"
                      >
                        Upgrade Now
                      </Link>
                    </>
                  ) : (
                    <Text fontSize={'sm'}>
                      Your account does not have the permissions required to upgrade billing. Please
                      contact the account administrator to perform an account upgrade.
                    </Text>
                  )}
                </ModalFooter>
              </Box>
            </ModalBody>{' '}
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default UpgradeSubscriptionModal
